import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";

import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import logistics from "../../../../services/logistics_appCommonService";

//Redux
import { useSelector, useDispatch } from "react-redux";
import { getCurrentDate, getTodaysData } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

import { getTransportList } from "../../../../redux/feature/logistics_app/logisticsSlice";

const PlPaymentExpensesTripModel = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  let userData = useSelector((state) => state?.user?.data);
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState(null);
  const hide = true;

  const [getTransactionType, setTransactionType] = useState();

  /* pop failure modal data*/
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };
  const paymentModeOptions = [
    { id: 1, code: "EK", name: "Cash", description: "Cash desc" },
    { id: 2, code: "BK", name: "Bank", description: "Bank desc" },
  ];
  const getType = [
    { id: 1, code: "DEBIT", name: "Payment", description: "Payment" },
    { id: 2, code: "CREDIT", name: "Receipt", description: "Receipt" },
  ];
  const getCompnayBank = [
    //  { id:1,name: "CASH", code: "EK" },
    { id: 2, name: "HDFC BANK", code: "BK" },
    { id: 3, name: "UNION BANK OF INDIA", code: "BK" },
    { id: 4, name: "ICICI BANK OF INDIA", code: "BK" },
  ];
  const transactionType = [
    { id: 1, code: "NEFT", name: "NEFT", description: "NEFT" },
    { id: 2, code: "CHEQUE", name: "CHEQUE", description: "CHEQUE" },
    { id: 3, code: "RTGS", name: "RTGS", description: "RTGS" },
    { id: 4, code: "CASH", name: "CASH", description: "CASH" },
    { id: 5, code: "UPI", name: "UPI", description: "UPI" },
  ];
  const expenseData = [
    { id: 1, name: "Salary", description: "Salary", code: "SL" },
    { id: 2, name: "EV Charges", description: "EV Charges", code: "EC" },
    {
      id: 3,
      name: "Vehicle Repair and Maintanance",
      description: "Vehicle Repair and Maintanance",
      code: "VRM",
    },
    { id: 4, name: "Diesel", description: "Diesel ", code: "DE" },
    {
      id: 5,
      name: "Telephone and Mobile",
      description: "Telephone and Mobile",
      code: "TMB",
    },
    { id: 6, name: "Miscellaneous", description: "Miscellaneous", code: "ME" },
  ];
  const [getFailureCashRequest] = useState(failureCashRequest);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);

  const [getCustomer, setCustomer] = useState([]);

  const [cashRequest, setCashRequest] = useState({
    cashRequestDate: getTodaysData(),
    createdBy: userData?.userId || "",
    cashRequestNr: "",
    cashRequestStatus: "Cash in Transit",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: 0,
    cashAmountInWords: "",
    debitAmount: 0,
    creditAmount: 0,

    bankTransactionDate: "",
    customerBankName: "",
    customerBank: "",
    companyBank: "",
    companyBankName: "",
    receivedBy: userData?.firstName || "",
    receiverContactNumber: userData?.contactNumber || "",
    type: "DEBIT",
    typeCode: "Payment",
    typeCodeDesc: "Payment",
    expenseName: "Advance",
    expenseType: "Advance",
    expenseTypeCode: "AD",
  });
  //Validations
  const [validation, setValidation] = useState({
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: "",
    receiverContactNumber: "",
  });
  const [getEditmode, setEditMode] = useState(false);
  // eslint-disable-next-line
  const [getCompanyCode, setCompanyCode] = useState([]);

  useEffect(() => {
    const loadMasterData = async () => {
      let obj1 = {
        codeType: "companyCode",
      };
      await ItemService.getMasterData(obj1).then((item) => {
        // console.log(">> item! companyCode title", item);
        if (item?.status === 200) {
          setCompanyCode(item?.data);
        } else {
          setCompanyCode([]);
          console.log(">> Error: Loading Company Code");
        }
      });

      let obj2 = {
        queryName: "get_driver_list",
      };

      await ItemService.generateCustomerQuery(obj2).then((item) => {
        if (item?.status === 200) {
          const transformed = item.data.map((cust) => ({
            id: cust.id,
            name: cust.code,
            desc: cust.code,
          }));
          setCustomer(transformed);
        } else {
          setCustomer([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    };
    loadMasterData();
  }, []);

  //getting customer name
  useEffect(() => {
    setCashRequest({
      createdBy: userData?.userId || "",
      cashRequestNr: "",
      cashRequestDate: getTodaysData() || "",
      cashRequestStatus: "Cash in Transit",
      salesOfficerCode: "",
      salesOfficerName: "",
      customerCode: "",
      customerName: "",
      paymentPurpose: "",
      paymentMode: "",
      cashAmount: "",
      cashAmountInWords: "",
      receivedBy: "",
      receiverContactNumber: "",
    });
  }, [userData]);
  /* let party = [
    { id: "V", name: "Vendor", desc: "Vendor" },
    { id: "S", name: "Supplier", desc: "Supplier" },
    { id: "C", name: "Company", desc: "Company" },
    { id: "E", name: "Employee", desc: "Employee" },
    { id: "C", name: "Customer", desc: "Customer" },
  ]; */
  //Customer drop down
  const isInitialLoad = useRef(true);

  const convertNumberToWords = (num) => {
    if (num === "" || isNaN(num)) return "";
    num = parseFloat(num).toFixed(2); // Ensure two decimal places
    let [rupees, paise] = num.split(".");
    rupees = parseInt(rupees);
    paise = parseInt(paise);

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

    const convertBelowThousand = (n) => {
      if (n < 20) return ones[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
      );
    };

    let words = "";
    let scaleIndex = 0;

    while (rupees > 0) {
      let part = rupees % 1000;
      if (part !== 0) {
        words =
          convertBelowThousand(part) +
          " " +
          scales[scaleIndex] +
          (words ? " " + words : "");
      }
      rupees = Math.floor(rupees / 1000);
      scaleIndex++;
    }

    words = words.trim() ? words.trim() + " Rupees" : "";

    if (paise > 0) {
      let paiseWords = convertBelowThousand(paise) + " Paise";
      words += " and " + paiseWords;
    }

    return words || "Zero Rupees";
  };

  useEffect(() => {
    if (props?.data) {
      isInitialLoad.current = true;
    }

    setEditMode(
      props?.data?.logisticsPayment === "PAYMENTSUCESSFULL" ? true : false
    );

    if (props?.data) {
      console.log(">>propsData", props?.data);
      setCashRequest({
        ...props.data,
        party: "Employee",
        partyCode: "E",
        partyDesc: "Employee",
        expenseType: "Advance",
        expenseTypeCode: "AD",

        expenseName: "Advance",
        expenseNameCode: "AD",
        expenseNameDesc: "Advance",

        type: "DEBIT",
        typeCode: "Payment",
        typeCodeDesc: "Payment",

        customer: props?.data?.driverName1,
        customerCode: props?.data?.driverCode || props?.data?.driverName1Desc,
        customerCodeDesc:
          props?.data?.driverCode || props?.data?.driverName1Desc,

        paymentMode: "Bank",
        paymentModeCode: "BK",
        paymentModeDesc: "Bank desc",

        companyBankName: "ICICI BANK OF INDIA",
        companyBankNameCode: "BK",
        companyBankNameDesc: "ICICI BANK OF INDIA",

        transactionMode: "NEFT",
        transactionModeCode: "NEFT",
        transactionModeDesc: "NEFT",

        cashRequestDate: getTodaysData(),
        bankTransactionDate: getTodaysData(),

        cashAmount:
          (props?.data?.transferType === "IGST" ? Number(3400) : Number(4000)) +
            Number(props?.data?.previousTripChargesAmount) || 0,
        debitAmount:
          (props?.data?.transferType === "IGST" ? Number(3400) : Number(4000)) +
            Number(props?.data?.previousTripChargesAmount) || 0,
        cashAmountInWords: convertNumberToWords(
          (props?.data?.transferType === "IGST" ? Number(3400) : Number(4000)) +
            Number(props?.data?.previousTripChargesAmount) || 0
        ),
      });
    }
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false; // Reset for next user interactions
      return;
    }

    // Only process if we have valid dropdown data
    if (!getDropdownData || !getDropdownData.code || !getDropdownData.name) {
      return;
    }

    if (getDropdownData?.textField === "party") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "paymentMode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setTransactionType(getDropdownData?.code);
      // getProjectDetailsByCode(getDropdownData?.id);
    } else if (getDropdownData?.textField === "expenseName") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "type") {
      setCashRequest((prev) => {
        const updated = {
          ...prev,
          [getDropdownData?.textField]: getDropdownData?.code,
        };

        // ✅ Always use the current cashAmount (not stale prev.cashAmount)
        const currentAmount = Number(prev.cashAmount) || 0;

        if (currentAmount > 0) {
          if (getDropdownData?.code === "CREDIT") {
            updated.creditAmount = currentAmount;
            updated.debitAmount = 0;
          } else if (getDropdownData?.code === "DEBIT") {
            updated.debitAmount = currentAmount;
            updated.creditAmount = 0;
          }
        }

        return updated;
      });

      // setPaymentType(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      // getProjectDetailsByCode(getDropdownData?.id);
    } else {
      setCashRequest((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  const handleInputChange = ({ target: { name, value } }) => {
    const errors = {};

    const convertNumberToWords = (num) => {
      if (num === "" || isNaN(num)) return "";
      num = parseFloat(num).toFixed(2); // Ensure two decimal places
      let [rupees, paise] = num.split(".");
      rupees = parseInt(rupees);
      paise = parseInt(paise);

      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];

      const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

      const convertBelowThousand = (n) => {
        if (n < 20) return ones[n];
        if (n < 100)
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
        );
      };

      let words = "";
      let scaleIndex = 0;

      while (rupees > 0) {
        let part = rupees % 1000;
        if (part !== 0) {
          words =
            convertBelowThousand(part) +
            " " +
            scales[scaleIndex] +
            (words ? " " + words : "");
        }
        rupees = Math.floor(rupees / 1000);
        scaleIndex++;
      }

      words = words.trim() ? words.trim() + " Rupees" : "";

      if (paise > 0) {
        let paiseWords = convertBelowThousand(paise) + " Paise";
        words += " and " + paiseWords;
      }

      return words || "Zero Rupees";
    };

    // Handle cashAmount logic
    if (name === "cashAmount") {
      if (!isNaN(value) && value !== "") {
        setCashRequest((prev) => {
          const updated = {
            ...prev,
            cashAmount: value,
            cashAmountInWords: convertNumberToWords(value),
          };

          if (prev.type === "CREDIT") {
            updated.creditAmount = value;
            updated.debitAmount = 0;
          } else if (prev.type === "DEBIT") {
            updated.debitAmount = value;
            updated.creditAmount = 0;
          }

          return updated;
        });
      } else {
        setCashRequest((prev) => ({
          ...prev,
          cashAmount: 0,
          cashAmountInWords: "",
          debitAmount: "",
          creditAmount: "",
        }));
      }
    } else {
      // default update for other fields
      setCashRequest((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const initialState = {
    createdBy: userData?.userId || "",
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: userData?.firstName,
    receiverContactNumber: userData?.contactNumber,
  };

  //handle cancel modal
  const handleCancel = () => {
    setCashRequest((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };
  const formatSlNo = (n, prefix = "V", width = 4) => {
    const numStr = String(n);
    const padded = numStr.padStart(Math.max(width, numStr.length), "0");
    return `${prefix}${padded}`;
  };
  const generateVouchNumber = async () => {
    const obj = { sequenceName: "VOUCHER" };

    try {
      const res = await ItemServiceV2.newSequenceNumber(obj);

      // Case 1: if your service returns axios-style { status, data }
      if (res?.status === 200 && res.data?.sequenceNo) {
        return res.data.sequenceNo;
      }

      // Case 2: if it directly returns { sequenceNo }
      if (res?.sequenceNo) {
        return res.sequenceNo;
      }

      console.error(">> Error: Invalid sequence response", res);
      return null;
    } catch (error) {
      console.error("Error generating voucher number", error);
      return null;
    }
  };
  //new working code
  const handleSave = async () => {
    props.onHide();
    const allPayloads = [];
    const sequenceNo = await generateVouchNumber();
    if (!sequenceNo) {
      toast.error("Failed to generate voucher number");
      return;
    }
    const voucherNumber = formatSlNo(sequenceNo);
    const credit = parseFloat(cashRequest.creditAmount || 0);
    const debit = parseFloat(cashRequest.debitAmount || 0);
    const type = cashRequest.type;

    let originalPayload, reversePayload;

    if (type === "DEBIT") {
      // Company pays (Salary, Expense, etc.)
      // Company credited, Customer debited
      originalPayload = {
        data: {
          voucherNumber,
          expensesHead: cashRequest.expensesHead || "",
          companyCode: cashRequest.companyCode || "",
          companyCode2: "",
          companyCodeDesc: cashRequest?.companyCodeDesc || "",
          customerCodeDesc: cashRequest?.customer || "",
          transaction: "Payment",
          transactionType: cashRequest?.paymentModeCode || "",
          customerCode: "",
          bankName: cashRequest.companyBankName || "",
          customrBankName: cashRequest.customrBankName || "",
          companyBank: cashRequest.companyBankName || "",

          transactionMode: cashRequest.transactionMode,
          bankTransactionDate: cashRequest.cashRequestDate || "",
          partyCode: cashRequest.partyCode,
          remarks: cashRequest.paymentPurpose,
          type: "CREDIT", // ✅ Company credited
          items: [
            {
              slNo: "1",
              creditAmount: debit, // ✅ company credited
              debitAmount: 0,
              transaction: "Payment",
            },
          ],
          documentNumber: cashRequest.documentNumber || "",
          invoiceNr: cashRequest.invoiceNr || "",
          invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
          createdBy: cashRequest.createdBy || "",
          createdByName: cashRequest.createdByName || "",
          createdAt: cashRequest.cashRequestDate || "",
          updatedAt: cashRequest.updatedAt || "",
          expenseName: cashRequest.expenseName || "",
          expenseNameCode: "AD" || "",
          postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          getTodaysData: cashRequest?.cashRequestDate || getTodaysData(),
        },
      };

      reversePayload = {
        data: {
          voucherNumber,
          companyCode: "",
          expensesHead: cashRequest.expensesHead || "",
          companyCode2: cashRequest.companyCode,
          companyCodeDesc: cashRequest?.companyCodeDesc || "",
          customerCodeDesc: cashRequest?.customer || "",
          transaction: "Payment",
          transactionType: cashRequest?.paymentModeCode || "",
          customerCode: cashRequest.customerCode || "",
          customerBankName: cashRequest.customrBankName || "",
          customerBank: cashRequest.customrBankName || "",
          companyBank: cashRequest.companyBankName || "",
          transactionMode: cashRequest.transactionMode || "",
          bankTransactionDate: cashRequest.cashRequestDate || "",
          partyCode: cashRequest.partyCode || "",
          remarks: cashRequest.paymentPurpose,
          type: "DEBIT", // ✅ Customer debited
          items: [
            {
              slNo: "1",
              creditAmount: 0,
              debitAmount: debit, // ✅ driver debited
              transaction: "Payment",
            },
          ],
          documentNumber: cashRequest.documentNumber || "",
          invoiceNr: cashRequest.documentNumber || "",
          invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
          createdBy: cashRequest.createdBy || "",
          createdByName: cashRequest.createdByName || "",
          createdAt: cashRequest.createdAt || "",
          updatedAt: cashRequest.updatedAt || "",
          expenseName: cashRequest.expenseName || "",
          expenseNameCode: "AD" || "",
          postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          getTodaysData: cashRequest?.cashRequestDate || getTodaysData(),
        },
      };
    } else if (type === "CREDIT") {
      // Customer pays (Income, Receipt, etc.)
      // Company debited, Customer credited
      originalPayload = {
        data: {
          voucherNumber,
          expensesHead: cashRequest.expensesHead || "",
          companyCode: cashRequest.companyCode || "",
          companyCode2: "",
          companyCodeDesc: cashRequest?.companyCodeDesc || "",
          customerCodeDesc: cashRequest?.customer || "",
          transaction: "Receipt",
          transactionType: cashRequest?.paymentModeCode || "",
          customerCode: "",
          bankName: cashRequest.companyBankName || "",
          customrBankName: cashRequest.customrBankName || "",
          companyBank: cashRequest.companyBankName || "",
          transactionMode: cashRequest.transactionMode || "",
          bankTransactionDate: cashRequest.cashRequestDate || "",
          partyCode: cashRequest.partyCode,
          remarks: cashRequest.paymentPurpose,
          type: "DEBIT", // ✅ Company debited
          items: [
            {
              slNo: "1",
              creditAmount: 0,
              debitAmount: credit, // ✅ company debited
              transaction: "Receipt",
            },
          ],
          documentNumber: cashRequest.documentNumber || "",
          invoiceNr: cashRequest.invoiceNr || "",
          invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
          createdBy: cashRequest.createdBy || "",
          createdByName: cashRequest.createdByName || "",
          createdAt: cashRequest.createdAt || "",
          updatedAt: cashRequest.updatedAt || "",
          expenseName: cashRequest.expenseName || "",
          expenseNameCode: "AD" || "",
          postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          getTodaysData: cashRequest?.cashRequestDate || getTodaysData(),
        },
      };

      reversePayload = {
        data: {
          voucherNumber,
          companyCode: "",
          expensesHead: cashRequest.expensesHead || "",
          companyCode2: cashRequest.companyCode,
          companyCodeDesc: cashRequest?.companyCodeDesc || "",
          customerCodeDesc: cashRequest?.customer || "",
          transaction: "Receipt",
          transactionType: cashRequest?.paymentModeCode || "",
          customerCode: cashRequest.customerCode || "",
          customrBankName: cashRequest.customrBankName || "",
          customerBank: cashRequest.customrBankName || "",
          companyBank: cashRequest.companyBankName || "",
          transactionMode: cashRequest.transactionMode || "",
          bankTransactionDate: cashRequest.cashRequestDate || "",
          partyCode: cashRequest.partyCode || "",
          remarks: cashRequest.remarks || "",
          type: "CREDIT", // ✅ Customer credited
          items: [
            {
              slNo: "1",
              creditAmount: credit, // ✅ customer credited
              debitAmount: 0,
              transaction: "Receipt",
            },
          ],
          documentNumber: cashRequest.documentNumber || "",
          invoiceNr: cashRequest.documentNumber || "",
          invoiceStatusHeader: cashRequest.invoiceStatusHeader || "",
          createdBy: cashRequest.createdBy || "",
          createdByName: cashRequest.createdByName || "",
          createdAt: cashRequest.createdAt || "",
          updatedAt: cashRequest.updatedAt || "",
          expenseName: cashRequest.expenseName || "",
          expenseNameCode: "AD" || "",
          postingDate: cashRequest?.cashRequestDate || getTodaysData(),
          getTodaysData: cashRequest?.cashRequestDate || getTodaysData(),
        },
      };
    }

    if (originalPayload) allPayloads.push(originalPayload);
    if (reversePayload) allPayloads.push(reversePayload);
    setDisabled(true);
    const failedEntries = [];

    const object = {
      ...cashRequest,
      cashRequestDate: cashRequest?.cashRequestDate,
      companyCode: cashRequest?.companyCode,
      companyCodeDesc: cashRequest?.companyCodeDesc,
      party: cashRequest?.party,
      partyCode: cashRequest?.partyCode,
      partyDesc: cashRequest?.partyDesc,
      expenseName: "Advance",
      expenseNameCode: "AD",
      expenseNameDesc: "Advance",
      paymentMode: cashRequest?.paymentMode,
      paymentModeCode: cashRequest?.paymentModeCode,
      paymentModeDesc: cashRequest?.paymentModeDesc,
      companyBankName: cashRequest?.companyBankName,
      companyBankNameCode: cashRequest?.companyBankNameCode,
      companyBankNameDesc: cashRequest?.companyBankNameDesc,
      transactionMode: cashRequest?.transactionMode,
      expensesHead: cashRequest?.expensesHead,
      cashAmount: cashRequest?.cashAmount,
      cashAmountInWords: cashRequest?.cashAmountInWords,
      customrBankName: cashRequest?.customrBankName,
      bankTransactionDate: cashRequest?.bankTransactionDate,
      customer: cashRequest?.customer,
      customerCode: cashRequest?.customerCode,
      customerCodeDesc: cashRequest?.customerCodeDesc,
      receiverContactNumber: cashRequest?.receiverContactNumber,
      type: cashRequest?.type,
      typeCode: cashRequest?.typeCode,
      typeCodeDesc: cashRequest?.typeCodeDesc,
      debitAmount: cashRequest?.debitAmount,
      creditAmount: cashRequest?.creditAmount,
      paymentPurpose: cashRequest?.paymentPurpose,
      logisticsPayment: "PAYMENTSUCESSFULL",
      paymentStatus: "Advance Paid",
      paymentDescript: `TRIP ${
        cashRequest?.documentNumber
      } ${cashRequest?.customer?.toUpperCase()}`,
      driverPaymentKey: "DPA",
      pymtPrdTypeCode: "PAB_VENDOR",
      pymtMode: "NEFT",
      debitAccNo: "035705005015",
      paymentDate: getCurrentDate(),
    };

    try {
      const updateResponse = await logistics.updateLogisticsTransport(object);

      if (!updateResponse || updateResponse.status !== 200) {
        toast.error("Update failed");
        return;
      }
      for (const payload of allPayloads) {
        const response = await ItemServiceV2.addInvoice(payload);
        if (!response || response.status !== 200) {
          failedEntries.push(
            payload.data.companyCodeDesc || payload.data.companyCode
          );
        }
      }

      if (failedEntries.length === 0) {
        toast.success("All bank statements uploaded successfully", {
          duration: 3000,
          position: "top-right",
        });

        let obj = {
          queryName: "getLogisticsTransportListINT",
          module: "",
          page: 1,
          per_page: 10,
        };
        dispatch(getTransportList(obj));
        // dispatch(
        //   getBankStatement({
        //     queryName: "Customer_BankAndExpenses_List",
        //     transactionType: "BK",
        //     page: 1,
        //     per_page: 10,
        //   })
        // );
        // dispatch(
        //   getCashExpenses({
        //     queryName: "Customer_BankAndExpenses_List",
        //     module: "CUSTOMER",
        //     transactionType: "EK",
        //     page: 1,
        //     per_page: 10,
        //   })
        // );

        // setShowDataModal(false);
      } else {
        toast.error(`Failed to upload for: ${failedEntries.join(", ")}`, {
          duration: 5000,
          position: "top-right",
        });
      }
    } catch (err) {
      toast.error("Something went wrong during upload", {
        duration: 5000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Advance Payment
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">AP</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Advance Payment</span>
                  <span className="subHeaderTitle">
                    Advance Payment details
                  </span>
                </Col>
              </Row>
            </h2>

            {/* 01 */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-body">
                <Row className="pt-2 pb-4">
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      type="date"
                      label="Created Date"
                      name="cashRequestDate"
                      min="1990"
                      id="cashRequestDate"
                      value={cashRequest?.cashRequestDate}
                      onChange={handleInputChange}
                      disabled={getEditmode}
                    />
                  </Col>
                  {/* <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
                    <ComboboxField
                      label="Company Name"
                      placeholder=""
                      data={getCompanyCode}
                      id="companyCode"
                      iconClassName="dropdownIcon"
                      name="companyCode"
                      code="companyCode"
                      description="companyCodeDesc"
                      setValue={cashRequest.companyCode || ""}
                      getvalue={setDropdownData}
                      required={true}
                      disabled={getEditmode}
                      error={validation.companyCode}
                    />
                  </Col> */}
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <ComboboxField
                      label="Driver"
                      placeholder=""
                      data={getCustomer}
                      id="customer"
                      iconClassName="dropdownIcon"
                      name="customer"
                      code="customerCode"
                      description="customerCodeDesc"
                      setValue={cashRequest.customerCode || ""}
                      getvalue={setDropdownData}
                      required={true}
                      error={validation.customerCode}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Vehicle Number"
                      name="vehicleNr"
                      id="vehicleNr"
                      value={cashRequest?.vehicleNr}
                      // onChange={handleInputChange}
                      disabled={true}
                    />
                  </Col>
                  {/* {getTransactionType === "BK" && (<> */}
                  {cashRequest?.paymentModeCode === "BK" && (
                    <>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Customer/Vendor/Employee BankName"
                          name="customrBankName"
                          id="customrBankName"
                          value={
                            cashRequest?.customerBandkDetails?.bankAccountNumber
                          }
                          // error={validation.receivedBy || ""}
                          onChange={handleInputChange || ""}
                          disabled={true}
                        />
                      </Col>
                    </>
                  )}
                  {/* <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commLeftRightPadding"
                                    >
                                      <ComboboxField
                                        label="Party"
                                        placeholder=""
                                        data={party}
                                        id="party"
                                        iconClassName="dropdownIcon"
                                        name="party"
                                        code="partyCode"
                                        description="partyDesc"
                                        setValue={cashRequest.party || ""}
                                        getvalue={setDropdownData}
                                        required={true}
                                        error={validation.party}
                                      />
                                    </Col> */}
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <ComboboxField
                      label="Payment Mode"
                      placeholder=""
                      data={paymentModeOptions}
                      id="paymentMode"
                      iconClassName="dropdownIcon"
                      name="paymentMode"
                      code="paymentModeCode"
                      description="paymentModeDesc"
                      setValue={cashRequest.paymentMode || ""}
                      getvalue={setDropdownData}
                      required={true}
                      disabled={getEditmode}
                      // error={validation.companyCode}
                    />
                  </Col>
                  {cashRequest.companyBankNameCode === "BK" && (
                    <>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        {/* comapny bank name */}

                        <ComboboxField
                          label="Company Bank Name"
                          placeholder=""
                          data={getCompnayBank}
                          id="companyBankName"
                          iconClassName="dropdownIcon"
                          name="companyBankName"
                          code="companyBankNameCode"
                          description="companyBankNameDesc"
                          setValue={cashRequest.companyBankName || ""}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={getEditmode}
                          // error={validation.companyCode}
                        />
                      </Col>
                    </>
                  )}
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Cash/Bank Transaction Date"
                      name="bankTransactionDate"
                      id="bankTransactionDate"
                      type="date"
                      min="1990"
                      value={cashRequest?.bankTransactionDate}
                      // error={validation.receivedBy || ""}
                      onChange={handleInputChange || ""}
                      disabled={getEditmode}
                    />
                  </Col>
                  {/* <Col
                                      xs={12}
                                      md={6}
                                      lg={4}
                                      className="commTopButtonRightLeftPadding"
                                    >
                                      <InputField
                                        className="inputBox"
                                        label="Bank UTR Number"
                                        placeholder="UTR"
                                        name="bankUtrNumber"
                                        id="bankUtrNumber"
                                        error={validation.bankUtrNumber || ""}
                                        value={cashRequest.bankUtrNumber || ""}
                                        onChange={handleInputChange}
                                      />
                                    </Col> */}
                  {/* <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Transaction Type"
                                placeholder="NEFT/IMPS/RTGS/CASH/UPI"
                                name="transactionMode"
                                id="transactionMode"
                                error={validation.transactionMode || ""}
                                value={cashRequest.transactionMode || ""}
                                onChange={handleInputChange}
                              />
                            </Col> */}
                  <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
                    <ComboboxField
                      label="Transaction Type"
                      placeholder=""
                      data={transactionType}
                      id="transactionMode"
                      iconClassName="dropdownIcon"
                      name="transactionMode"
                      code="transactionModeCode"
                      description="transactionModeDesc"
                      setValue={cashRequest.transactionMode || ""}
                      getvalue={setDropdownData}
                      required={true}
                      disabled={getEditmode}
                      // error={validation.companyCode}
                    />
                  </Col>
                  {getTransactionType === "BK" &&
                    cashRequest?.transactionMode === "CHEQUE" && (
                      <>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Cheque Number"
                            placeholder=""
                            name="chequeNumber"
                            id="chequeNumber"
                            error={validation.chequeNumber || ""}
                            value={cashRequest.chequeNumber || ""}
                            onChange={handleInputChange}
                            disabled={getEditmode}
                          />
                        </Col>
                      </>
                    )}

                  {/* {getTransactionType === "BK" &&
                    (cashRequest?.transactionMode === "NEFT" ||
                      cashRequest?.transactionMode === "RTGS" ||
                      cashRequest?.transactionMode === "UPI") && (
                      <>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="  NEFT/RTGS/UPI/CASH"
                            placeholder=""
                            name="transactionType"
                            id="transactionType"
                            // error={validation.transactionType || ""}
                            value={cashRequest.transactionType || ""}
                            onChange={handleInputChange}
                            disabled={getEditmode}
                          />
                        </Col>
                      </>
                    )} */}

                  {getTransactionType === "BK" &&
                    cashRequest?.transactionMode === "CHEQUE" && (
                      <>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Cheque Date"
                            placeholder=""
                            type="date"
                            min={1990}
                            name="chequeDate"
                            id="chequeDate"
                            error={validation.chequeDate || ""}
                            value={cashRequest.chequeDate || ""}
                            onChange={handleInputChange}
                            disabled={getEditmode}
                          />
                        </Col>
                      </>
                    )}

                  {getTransactionType === "EK" && (
                    <Col
                      xs={12}
                      md={6}
                      lg={4}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="Cash/Expenses Details"
                        placeholder=""
                        name="expensesHead"
                        id="expensesHead"
                        error={validation.expensesHead || ""}
                        value={cashRequest.expensesHead || ""}
                        onChange={handleInputChange}
                        disabled={getEditmode}
                      />
                    </Col>
                  )}
                  {cashRequest?.previousTripChargesCode === "YES" && (
                    <>
                      {" "}
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Previous Trip Charges Amount"
                          placeholder=""
                          name="previousTripChargesAmount"
                          id="previousTripChargesAmount"
                          error={validation.previousTripChargesAmount || ""}
                          value={cashRequest.previousTripChargesAmount || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bill Date"
                          placeholder="Enter amount"
                          name="billDate"
                          id="billDate"
                          error={validation.billDate || ""}
                          value={cashRequest.billDate || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Bill Number"
                          placeholder="Enter amount"
                          name="billNumber"
                          id="billNumber"
                          error={validation.billNumber || ""}
                          value={cashRequest.billNumber || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Previous Trip Charges Remarks"
                          placeholder=""
                          name="previousTripRemarks"
                          id="previousTripRemarks"
                          value={cashRequest?.previousTripRemarks || ""}
                          disabled={true} // Read-only field
                        />
                      </Col>
                    </>
                  )}
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Amount (INR)"
                      placeholder="Enter amount"
                      name="cashAmount"
                      id="cashAmount"
                      error={validation.cashAmount || ""}
                      value={cashRequest.cashAmount || ""}
                      onChange={handleInputChange}
                      disabled={getEditmode}
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <TextAreaField
                      className="inputBox"
                      label="Cash Amount in Words"
                      placeholder="Cash Amount in Words"
                      name="cashAmountInWords"
                      id="cashAmountInWords"
                      value={cashRequest.cashAmountInWords || ""}
                      disabled={true} // Read-only field
                    />
                  </Col>

                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <InputField
                      className="inputBox"
                      label="Contact Number"
                      name="receiverContactNumber"
                      id="receiverContactNumber"
                      value={cashRequest.receiverContactNumber || ""}
                      error={validation.receiverContactNumber || ""}
                      onChange={handleInputChange}
                      disabled={getEditmode}
                    />
                  </Col>
                  {!hide && (
                    <>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Type"
                          placeholder=""
                          data={getType}
                          id="type"
                          iconClassName="dropdownIcon"
                          name="type"
                          code="typeCode"
                          description="typeCodeDesc"
                          setValue={cashRequest.typeCodeDesc || ""}
                          getvalue={setDropdownData}
                          // required={true}
                          disabled={true}
                          // error={validation.type}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Debit Amount"
                          name="debitAmount"
                          id="debitAmount"
                          value={cashRequest.debitAmount ?? 0}
                          // error={validation.type || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Credit Amount"
                          name="creditAmount"
                          id="creditAmount"
                          value={cashRequest.creditAmount ?? 0}
                          // error={validation.type || ""}
                          onChange={handleInputChange}
                          disabled={true}
                        />
                      </Col>
                    </>
                  )}

                  <Col xs={12} md={6} lg={4} className="commLeftRightPadding">
                    <ComboboxField
                      label="Expense Type"
                      placeholder=""
                      data={expenseData}
                      id="expenseName"
                      iconClassName="dropdownIcon"
                      name="expenseName"
                      code="expenseNameCode"
                      description="expenseNameDesc"
                      setValue={cashRequest.expenseName || "Advance"}
                      getvalue={setDropdownData}
                      // required={true}
                      error={validation.expenseName}
                      disabled={true}
                    />
                  </Col>
                  <Col
                    xs={12}
                    md={6}
                    lg={4}
                    className="commTopButtonRightLeftPadding"
                  >
                    <TextAreaField
                      className="inputBox"
                      label="Payment Purpose"
                      name="paymentPurpose"
                      id="paymentPurpose"
                      value={cashRequest.paymentPurpose}
                      error={validation.paymentPurpose || ""}
                      onChange={handleInputChange}
                      disabled={getEditmode}
                    />
                  </Col>
                </Row>
              </div>
            </div>

            {!getEditmode && (
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btn btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            )}
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
          requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default PlPaymentExpensesTripModel;
